import React from 'react';
import {updateStepData} from 'api';
import {getWorkingMemory} from '../../constants/tests.js';

import AdminTestPanel from '../../components/AdminTestPanel';
import strings from '../../strings';
import AdminReadyButton from '../../components/AdminReadyButton';

const WM_STAGES = {
	NUMBERS_INTRO: 0,
	NUMBERS_TRIAL: 1,
	WAITING_POST_TRIAL: 2,
	NUMBERS_TEST: 3,
	WAITING: 4,
	WORDS_INTRO: 5,
	/* WORDS_TRIAL: 6,
	WAITING_POST_TRIAL2: 7, */
	WORDS_TEST: 6,
	WAITING2: 7,
};

/* 
	original value

	NUMBERS_INTRO: 0,
	NUMBERS_TEST: 1,
	WAITING: 2,
	WORDS_INTRO: 3,
	WORDS_TEST: 4,
	WAITING2: 5,

*/
class WorkingMemoryWordsAdmin extends AdminTestPanel {
	constructor(props) {

		super(props, {
			stopOnConsecutiveErrors: false,
			enableTimers: false,
		});

		this._trialAdvanced = false;
		this._lastStage = null;
		this._lastStep = null;
	}

	getTestName = (flag) => {
		if (flag === 'words') return strings.wsw_testname;
		else return strings.wsn_testname;
	};

componentWillReceiveProps(newProps) {
  super.componentWillReceiveProps(newProps);

  const sd = (newProps && newProps.stepData) || {};

  const isTrialStage =
    newProps.currentStage === WM_STAGES.NUMBERS_TRIAL ||
    newProps.currentStage === WM_STAGES.WORDS_TRIAL;

  // reset guard when stage/step changes
  if (
    this._lastStage !== newProps.currentStage ||
    this._lastStep !== newProps.currentStep
  ) {
    this._trialAdvanced = false;
    this._lastStage = newProps.currentStage;
    this._lastStep = newProps.currentStep;
  }

  // ✅ TRIAL: proceed once feedback is done
  if (isTrialStage && sd.answered && sd.feedbackDone && !this._trialAdvanced) {
    this._trialAdvanced = true;
    this.props.nextStep();
  }

  // existing reset when words test starts
  if (
    this.props.currentStage !== newProps.currentStage &&
    newProps.currentStage === WM_STAGES.WORDS_TEST &&
    this.state.options.stopOnConsecutiveErrors
  ) {
    this.setState({ consecutiveErrors: 0 });
  }
}
	answerTrial = (verdict) => {
  const correct = verdict === 'correct';

  updateStepData({
    correct,            // candidate picks correct/incorrect audio
    feedbackDone: false,
    answered: false,    // IMPORTANT: don't advance yet
  });
};

	answerCorrect = (numberOfCorrect = true) => {
		const {results, correctAnswers, currentStage, currentStep} = this.state;
		const testName =
			currentStage === WM_STAGES.NUMBERS_TEST ? 'numbers' : 'words';

		const newResults = Object.assign({}, results, {
			[testName]: {
				...results[testName],
				[currentStep]: {
					isCorrect: numberOfCorrect,
					isAnswered: true,
				},
			},
		});

		this.setState({
			results: newResults,
			correctAnswers: correctAnswers + 1,
			consecutiveErrors: 0,
		});
		this.props.nextStep(newResults); //changing state object to regular object
	};

	answerWrong = () => {
		const {consecutiveErrors, currentStage, currentStep, results, options} =
			this.state;

		const testName =
			currentStage === WM_STAGES.NUMBERS_TEST ? 'numbers' : 'words';

		const newResults = Object.assign({}, results, {
			[testName]: {
				...results[testName],
				[currentStep]: {
					isCorrect: false,
					isAnswered: true,
				},
			},
		});

		this.setState(
			{
				wrongAnswers: this.state.wrongAnswers + 1,
				results: newResults,
				consecutiveErrors: consecutiveErrors + 1,
			},
			() => {
				const currErrors = this.state.consecutiveErrors;
				const maxErrors = options.maxConsecutiveErrors;
				if (
					currErrors >= maxErrors &&
					options.stopOnConsecutiveErrors
				) {
					if (testName === 'words')
						this.props.submitResults(this.state.results);
					this.setState({
						consecutiveErrors: 0,
					});
					this.props.nextStage();
				} else {
					this.props.nextStep(this.state.results);
				}
			}
		);
	};

	answerUnanswered = () => {
		const {consecutiveErrors, currentStage, currentStep, results, options} =
			this.state;

		const testName =
			currentStage === WM_STAGES.NUMBERS_TEST ? 'numbers' : 'words';

		const newResults = Object.assign({}, results, {
			[testName]: {
				...results[testName],
				[currentStep]: {
					isCorrect: false,
					isAnswered: false,
				},
			},
		});

		this.setState(
			{
				unanswered: this.state.unanswered + 1,
				results: newResults,
				consecutiveErrors: consecutiveErrors + 1,
			},
			() => {
				const currErrors = this.state.consecutiveErrors;
				const maxErrors = options.maxConsecutiveErrors;
				if (
					currErrors >= maxErrors &&
					options.stopOnConsecutiveErrors
				) {
					if (testName === 'words')
						this.props.submitResults(this.state.results);
					this.props.nextStage();
				} else {
					this.props.nextStep(this.state.results);
				}
			}
		);
	};

	handleKeyPress = (event) => {
  const {
    options: {limitHotkeysToTest, enableHotkeys},
    currentStage,
  } = this.state;

  if (!enableHotkeys) return;

  const isTrialStage =
    currentStage === WM_STAGES.NUMBERS_TRIAL ||
    currentStage === WM_STAGES.WORDS_TRIAL;

  const isAllowedStage =
    !limitHotkeysToTest ||
    [WM_STAGES.NUMBERS_TRIAL, WM_STAGES.NUMBERS_TEST, WM_STAGES.WORDS_TRIAL, WM_STAGES.WORDS_TEST].includes(currentStage);

  if (!isAllowedStage) return;

  if (isTrialStage) {
    if (event.key === 'a') this.answerTrial('correct');
    if (event.key === 'l') this.answerTrial('wrong');
    if (event.key === 'k') this.answerTrial('unanswered');
    return;
  }

  // normal test stages
  if (event.key === 'a') this.answerCorrect();
  if (event.key === 'l') this.answerWrong();
  if (event.key === 'k') this.answerUnanswered();
};

	renderIntro = (version) => {
		return (
			<>
				<p>
					{strings.ws_admin1}
					<br />
					{version === 'numbers'
						? strings.wsn_admin2
						: strings.wsw_admin2}
					<br />

					{version === 'numbers'
						? strings.wsn_admin2part2
						: strings.wsw_admin2part2}
				</p>

				

				<p>
					{version === 'numbers'
						? strings.wsn_admin2part2
						: strings.wsw_admin2part3}

							<br />
					{strings.getLanguage() === 'de'
						? strings.clickStartWhenReadyEmpty
						: strings.clickStartWhenReady}
				</p>

				<p>{strings.workingMemoryClickStart}</p>
				<AdminReadyButton
					remoteIsReady={this.props.candidateReady}
					onClick={this.props.nextStage}
				/>
			</>
		);
	};
	
	renderButtonsForTrials = () => (
  <>
    <button
		disabled={
  (this.props.stepData &&
    this.props.stepData.feedbackDone === false &&
    typeof this.props.stepData.correct === 'boolean') || false
}
      onClick={(e) => {
        e.stopPropagation();
        this.answerTrial('correct');
      }}
    >
      {strings.hotkeyButtonCorrect}
    </button>

    <button
      disabled={
  (this.props.stepData &&
    this.props.stepData.feedbackDone === false &&
    typeof this.props.stepData.correct === 'boolean') || false
}
      onClick={(e) => {
        e.stopPropagation();
        this.answerTrial('wrong');
      }}
    >
      {strings.hotkeyButtonWrong}
    </button>

    <button
      disabled={
  (this.props.stepData &&
    this.props.stepData.feedbackDone === false &&
    typeof this.props.stepData.correct === 'boolean') || false
}
      onClick={(e) => {
        e.stopPropagation();
        this.answerTrial('unanswered');
      }}
    >
      {strings.hotkeyButtonUnanswered}
    </button>
  </>
);

	renderButtons = () => (
		<>
			<button
				onClick={(e) => {
					e.stopPropagation();
					this.answerCorrect();
				}}
			>
				{strings.hotkeyButtonCorrect}
			</button>
			<button
				onClick={(e) => {
					e.stopPropagation();
					this.answerWrong();
				}}
			>
				{strings.hotkeyButtonWrong}
			</button>
			<button
				onClick={(e) => {
					e.stopPropagation();
					this.answerUnanswered();
				}}
			>
				{strings.hotkeyButtonUnanswered}
			</button>
		</>
	);

	renderTrial = (type) => {
		const {currentStep} = this.state;

		const dataset =
			type === 'numbers'
				? getWorkingMemory().getNumberTrialSteps()
				: getWorkingMemory().getWordTrialSteps();

		const row = dataset[currentStep].slice().reverse().join(' - ');

		return (
			<div>
				<p>
					<br />
					{type === 'numbers'
						? strings.wsn_admin3
						: strings.wsw_admin3}
					<br />
					{strings.hotkeyDescription}
					<br />
					{strings.hotkeyCorrect}
					<br />
					{strings.hotkeyWrong}
				</p>
				<p>
					{strings.formatString(
						strings.taskNumOf,
						currentStep + 1,
						dataset.length
					)}
				</p>
				<p>
					{strings.formatString(
						strings.expectedAnswer,
						<b style={{color: 'orange'}}>{row}</b>
					)}
				</p>
				{this.renderButtonsForTrials()}
			</div>
		);
	};

	renderTest = (type) => {
		const {currentStep} = this.state;

		const dataset =
			type === 'numbers'
				? getWorkingMemory().getNumberSteps()
				: getWorkingMemory().getWordSteps();

		const row = dataset[currentStep].slice().reverse().join(' - ');

		return (
			<div>
				<p>
					<br />
					{type === 'numbers'
						? strings.wsn_admin3
						: strings.wsw_admin3}
					<br />
					{strings.hotkeyDescription}
					<br />
					{strings.hotkeyCorrect}
					<br />
					{strings.hotkeyWrong}
				</p>
				<p>
					{strings.formatString(
						strings.taskNumOf,
						currentStep + 1,
						dataset.length
					)}
				</p>
				<p>
					{strings.formatString(
						strings.expectedAnswer,
						<b style={{color: 'orange'}}>{row}</b>
					)}
				</p>
				{this.renderButtons()}
			</div>
		);
	};

	renderWaiting = (type) => {
		return (
			<div>
				<p>
					{strings.formatString(
						strings.testDone,
						type !== 'words'
							? strings.wsn_testname
							: strings.wsw_testname
					)}
				</p>
				<button onClick={this.props.nextStage}>
					{strings.nextTest}
				</button>
			</div>
		);
	};

	renderWaitingTrial = (type) => {
		return (
			<div>
				{type === 'numbers' ? (
					<p>{strings.click_start}</p>
				) : (
					<p>{strings.click_start_words}</p>
				)}
				
				<p>{strings.click_start2}</p>
				<button onClick={this.props.nextStage}>
					{strings.nextTest}
				</button>
			</div>
		);
	};

	render() {
		const {currentStage: stage} = this.state;

		return (
			<div className="lit-intro">
				<h1 className="lit-page-title">
					{[0, 1, 2, 3, 4].includes(stage)
						? this.getTestName('numbers')
						: this.getTestName('words')}
				</h1>

				{stage === WM_STAGES.NUMBERS_INTRO &&
					this.renderIntro('numbers')}
				{stage === WM_STAGES.NUMBERS_TRIAL &&
					this.renderTrial('numbers')}
				{stage === WM_STAGES.WAITING_POST_TRIAL &&
					this.renderWaitingTrial('numbers')}

				{stage === WM_STAGES.NUMBERS_TEST && this.renderTest('numbers')}
				{stage === WM_STAGES.WAITING && this.renderWaiting('numbers')}
				{stage === WM_STAGES.WORDS_INTRO && this.renderIntro('words')}
				{/* {stage === WM_STAGES.WORDS_TRIAL && this.renderTrial('words')}
				{stage === WM_STAGES.WAITING_POST_TRIAL2 &&
					this.renderWaitingTrial('words')} */}

				{stage === WM_STAGES.WORDS_TEST && this.renderTest('words')}
				{stage === WM_STAGES.WAITING2 && this.renderWaiting('words')}
			</div>
		);
	}
}

export default WorkingMemoryWordsAdmin;
